var _defs, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOcr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a, .b { fill: none; stroke: #FFFFFF; stroke-linecap: round; stroke-linejoin: round; }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M17.1,5.5H5.5V18"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.5,29.9V42.5H16.9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M31,42.5H42.5V30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M42.5,18.2V5.5H30.9"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 9.7,
    y1: 11.2,
    x2: 38.8,
    y2: 11.2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 9.7,
    y1: 19.5,
    x2: 38.8,
    y2: 19.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 9.7,
    y1: 27.8,
    x2: 38.8,
    y2: 27.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 9.6,
    y1: 36.2,
    x2: 31.5,
    y2: 36.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOcr);
export default __webpack_public_path__ + "static/media/ocr.17463bbdbf3f09f6f5bda17e60bc7cad.svg";
export { ForwardRef as ReactComponent };